// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentLoader_root__1yfMs","loader":"ContentLoader_loader__3bc7A","disabled":"ContentLoader_disabled__3XqWu"};